/* eslint-disable */
<template>
<div class="pale-bg">
		<div class="projects-con d-flex pale-bg pt-4">
		<div
			class="social-links medium-font pl-0 pl-lg-1 ml-3 ml-lg-0 d-none d-md-block"
			v-rellax="{ speed: 2 }"
		>
			<a href="https://twitter.com/daveaji" class="black-text ml-5 mr-4">TWITTER</a> <span>/</span>
			<a href="https://github.com/Ajiva-D" class="black-text mx-4">GITHUB</a> <span>/</span>
			<a href="https://instagram.com/ajiva_d" class="black-text ml-4">INSTAGRAM</a>
		</div>
		<div class="pl-0 pl-lg-5">
			<b-container>
				<head-title title="Projects"></head-title>
				<b-row class="py-5 parallax-con">
					<b-col
						sm="12"
						md="5"
						lg="6"
						class="py-5 pl-0 px-2 px-md-0 pl-md-5 order-2 order-md-1 position-relative"
					>
					<div class="pl-0 pl-lg-5">
							<img
							:src="imgSrc"
							alt=""
							class="project-img red-shadow"
							data-aos="fade-right"
							data-aos-duration="1000"
							data-aos-offset="-500"
							v-rellax="{ center: true, speed: -1 }"
						/>
					</div>
						<div class="red-line"></div>
					</b-col>
					<b-col sm="12" md="7" lg="6" class="py-5 order-1 order-md-2">
						<div class="mb-5">
							<ul class="pl-0 pl-lg-3" data-aos="fade-up" data-aos-duration="500" 	data-aos-offset="-500"	>
								<li v-for="(project, index) in myprojects" :key="index">
									<project-list
										:id="project.id"
										:title="project.title"
										:text="project.text"
										:imgSrc="project.src"
										:link="project.link"
									></project-list>
								</li>
							</ul>
						</div>
						<a href="https://github.com/Ajiva-D/" class="github-link mt-5 pt-5">More on Github</a>
					</b-col>
				</b-row>
				<head-title title="About" id="About" class="pt-4"></head-title>
			</b-container>
		</div>
	</div>
</div>
</template>

<script>
// import {  } from "module";
import HeadTitle from "../components/HeadTitle";
import ProjectList from "../components/ProjectList";
import { BContainer, BRow, BCol } from "bootstrap-vue";
export default {
	components: {
		HeadTitle,
		BContainer,
		BRow,
		BCol,
		ProjectList
	},
	data() {
		return {
			myprojects: [
				{
					id: "01",
					title: "protraka",
					text:
						"A Diesel Management Solution that helps organizations and Individuals automate purchase and track consumption. Protraka organizes procurement activities, present real-time diesel monitoring from any location and auto-generates usage information.",
					src:
						"https://res.cloudinary.com/ajiva/image/upload/v1581707626/portfolio/Aji-plates-protraka.jpg",
					link:"https://protraka.com/"
				},
				{
					id: "02",
					title: "The Evening With Sagas",
					text:
						"A festival experience in the city of Uyo, brought together by the music artiste Sagas, with about 1000+ expected guests in an open air venue, vibing to great music by the best acts, food, games, fun and a strong festival ambience.",
					src:
						"https://res.cloudinary.com/ajiva/image/upload/v1579250411/portfolio/TheEvenningWithSagas_Savyphotos_2018-89.JPG.jpg",
					link:"https://theeveningwithsagas.com/"
				},
				{
					id: "03",
					title: "west edwin",
					text: "A Professional Website for West Edwin, a Financial Consultant.",
					src:
						"https://res.cloudinary.com/ajiva/image/upload/v1581707626/portfolio/Aji-plates-2.jpg",
					link:"https://westedwin.com/"
				},
				{
					id: "04",
					title: "truthX",
					text: "Web App for TruthX, a platform that helps people buy and sell giftcards and bitcoin instantly and safely.",
					src:
						"https://res.cloudinary.com/ajiva/image/upload/v1614806981/portfolio/truthxPreview.png",
					link:"https://truthx.co"
				},
					{
					id: "05",
					title: "manageam",
					text: "ManageAm is a mobile application built with Angularjs, Framework7 and cordova. It helps diabetic and people with high blood pressure monitor their levels, diets and gives proper information on how to take care of themselves",
					src:
						"https://res.cloudinary.com/ajiva/image/upload/v1614808177/portfolio/manageam.png",
					link:"https://play.google.com/store/apps/details?id=com.app.shei.manageam&hl=en_US&gl=US"
				},
			]
		};
	},
	computed: {
		imgSrc() {
			return this.$store.state.imgSrc;
		}
	}
};
</script>

<style scoped>
.project-con {
	width: 100%;
}
.social-links {
	writing-mode: vertical-rl;
	transform: rotate(-180deg);
	position: relative;
	top: 220px;
	/* height:20px; */
}
ul {
	width: 100%;
}
.project-img {
	width: 300px;
	height:400px;
	object-fit: cover;
	position: relative;
	z-index: 2;
	transition: all .5s ease-in-out;
}
.project-img:hover{
	filter: invert(100%);
	transition: all .5s ease-in-out;
}
.red-line{
	width:300px;
	background-color: #8d140e;
	height:1px;
	position: absolute;
	top:50%;
	transform:translateY(-50%);
	right:0;
	z-index: 1;
}
.github-link{
	color:#13120d;
}
.github-link:hover{
	color:#8d140e;
}
@media only screen and (max-width: 767px) {
	.project-img {
	width: 100%;
	height:100%;
}
}

@media only screen and (min-width: 768px) and (max-width: 999px) {
	.red-line{
	width:150px;
}
.project-img {
	width: 100%;
	height:400px;
	object-fit: cover;
	position: relative;
	z-index: 2;
}
}
@media only screen and (min-width: 2000px){
	.projects-con{
		max-width:1140px;
		margin:auto;
	}
}
</style>
